export const stopPropagation = (e) => {
  e.stopPropagation();
};



// WEBPACK FOOTER //
// ./services/stopPropagation.js